import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

import React, { Children } from 'react';
import classnames from 'classnames';

import { IconButton } from 'ui-components/components/button/icon-button';
import { FlexColumn } from 'ui-components/components/flex/column';
import { FlexRow } from 'ui-components/components/flex/row';
import { Text, TextType } from 'ui-components/components/text';

import styles from './styles.module.less';
import { messages } from './messages';
import { isScreenMobile, isScreenTablet, isScreenUltraMobile } from '../../constants/screen-width-breakpoints';

/**
 * @type {import('ui-components/components/text/text-types.d.ts/text-types.d.ts').TextValue} TextValue
 */

/**
 * NOTE: Supposedly there is a world where BannerMessageV2 and this promotional banner _should_ look the same.
 * https://www.figma.com/design/A1suqNxo7ab0Zq7gxCiwaE/ADL-Components?node-id=526-694&node-type=frame&m=dev
 *
 * However, the current implementation of BannerMessageV2 does not look like the promotional banner as intended by figma designs.
 * Will revist consoldation in the future
 * @param {object} props
 * @param {string} [props.className] - Optional custom class name
 * @param {TextValue} props.promotionalHeaderMessage - Required main header message to display on the promotional banner
 * @param {TextValue} [props.promotionalSubheaderMessage] - Optional secondary sub-header message to display on the promotional banner
 * @param {boolean} [props.sparkly] - Adds a sparkly theme instead of the standard purple
 * @param {() => void} [props.onClose] - Optional callback when close button is clicked
 * @param {ReactNode} props.children - These should be call to action buttons
 * @returns {JSX.Element}
 */
export const PromotionalBanner = ({
  className = '',
  promotionalHeaderMessage,
  promotionalSubheaderMessage = '',
  sparkly = false,
  onClose,
  children,
}) => {
  const hasAtMostOneCallToActionButton = Children.count(children) <= 1;
  const mobileView = isScreenTablet() || isScreenMobile() || isScreenUltraMobile();

  return (
    <FlexRow className={classnames(styles.banner, { [styles.sparkly]: sparkly }, className)}>
      <FlexRow className={styles.wrapper}>
        <FlexRow className={styles.header}>
          <FontAwesomeIcon className={styles.icon} icon={sparkly ? faSparkles : faBolt} />
          <FlexColumn>
            {promotionalHeaderMessage ? <Text textType={TextType.H4} value={promotionalHeaderMessage} /> : null}
            {promotionalSubheaderMessage ? <Text textType={TextType.Paragraph} value={promotionalSubheaderMessage} /> : null}
            {!hasAtMostOneCallToActionButton || mobileView ? <FlexRow className={styles.twoButtons}>{children}</FlexRow> : null}
          </FlexColumn>
        </FlexRow>
        {hasAtMostOneCallToActionButton && !mobileView ? children : null}
        {onClose ? (
          <IconButton
            ariaLabelMessageDescriptor={messages.dismissBanner}
            className={styles['close-button']}
            icon={faTimes}
            onClick={onClose}
          />
        ) : null}
      </FlexRow>
    </FlexRow>
  );
};
